import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";
import {
  noNetworkMsg,
  exErrMsg,
  successMsg,
  errorMsg,
  clearMsg,
  infoMsg,
} from "../Utils/apiToasts";
import { offline } from "../Constants/api";
import { controller } from "../Constants/api";

//===============Api for Create New Business Management========================
export const createBusinessManagement = async (body) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(`${controller.businessMgt}/create-BusinessManagement`,body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Added New Business", "Success");
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      errorMsg("An error occured", "error");
      throw ex
    }
  }
};

//===============Api for Fetch Business Management========================
export const getBusinessManagement = async (params) => {
    if (offline) {
      noNetworkMsg();
    } else {
      try {
        const response = await api.get(`${controller.businessMgt}/get-all-BusinessManagements`, {params});
        if (typeof response !== "undefined") {
          if (response.status === 200) {
            // successMsg("Fetched Business", "Success");
            return response.data;
          }
        } else {
          toastr.error("An error occured")
        }
      } catch (ex) {
        if(ex.response.data.status === 400){
          toastr.error("An Error occured", "Error")
        errorMsg(ex.response.data.title, "Error");
        }else{
         toastr.error("An error occured")
        }
      }
    }
  };


  //===============Api for Update Business Mgt========================
export const updateBusinessMgt = async (body) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.put(`${controller.businessMgt}/edit-BusinessManagement`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Updated Established Business", "Success");

          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      if (ex.response.status === 400) {
        errorMsg(ex.response.data.title, "");
      } else {
        exErrMsg();
      }
    }
  }
};
  //===============Api for Export Business Management as CSV ========================
export const exportBusiness = async () => {
    if (offline) {
      noNetworkMsg();
    } else {
      toastr.info("Downloading...", "Pending");
      await api
        .get(`${controller.businessMgt}/export-BusinessManagements`, { responseType: "blob" })
        .then((response) => {
          infoMsg("Downloading...");
          if (typeof response !== "undefined") {
            if (response.status === 200 || response.status === 204) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `SAED Manage Established Business ${generalFunc.getCurrentYear()}.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              clearMsg();
              successMsg("Download Established Business SpreadSheet", "Success");
            } else {
              clearMsg();
              errorMsg("Download Established Business SpreadSheet", "Error in fetching API");
            }
          }
        })
        .catch((ex) => {
          clearMsg();
          exErrMsg();
        });
    }
  };

  //===============Api for Fetch Business Management without Pagination ========================
export const getBusinessManagementWithoutPagination = async () => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(`${controller.businessMgt}/get-all-BusinessManagements-no-pagination`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // successMsg("Fetched Business", "Success");
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      errorMsg(ex.response.data.message, "");
    }
  }
};


  //===============Api for Fetch Total Business Management Details ========================
  export const getTotalBusinesManagement = async () => {
    if (offline) {
      noNetworkMsg();
    } else {
      try {
        const response = await api.get(`${controller.businessMgt}/get-total-BusinessManagements-details`);
        if (typeof response !== "undefined") {
          if (response.status === 200) {
            // successMsg("Fetched Total Business", "Success");
            return response.data.data;
          }
        } else {
          exErrMsg();
        }
      } catch (ex) {
        errorMsg(ex.response.data.message, "");
      }
    }
  };


 
  //===============Api for Fetch Business Management By Id ========================
export const getBusinessManagementByIdApi = async (id) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(`${controller.businessMgt}/get-BusinessManagement-by-id/${id}`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // successMsg("Fetched Business", "Success");
          return response.data.data;
        }
      } else {
        toastr.error("An error occured")
      }
    } catch (ex) {
      if(ex.response.data.status === 400){
        toastr.error("An Error occured", "Error")
      errorMsg(ex.response.data.title, "Error");
      }else{
       toastr.error("An error occured")
      }
    }
  }
};